import { render, staticRenderFns } from "./DeterAmazonia.vue?vue&type=template&id=6407995c&lang=pug"
import script from "./DeterAmazonia.vue?vue&type=script&lang=js"
export * from "./DeterAmazonia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports